import { render, staticRenderFns } from "./default.vue?vue&type=template&id=ed03408e"
import script from "./default.vue?vue&type=script&lang=js"
export * from "./default.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NavMain: require('/vercel/path0/components/navMain.vue').default,Footer: require('/vercel/path0/components/footer.vue').default,ChatButton: require('/vercel/path0/components/chatButton.vue').default,LoginModal: require('/vercel/path0/components/loginModal.vue').default})
